export default __webpack_public_path__ + "static/media/reverse_pendulum.0d8cf181.svg";